<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Beverley Gasner</span></p>
<p class="ded1"><span>And nobody but nobody else</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?14403db2